<script>
  let {
    emoji = $bindable(''),
    text = $bindable(''),
    emojiLabel = 'Emoji',
    textLabel = 'Label',
    error,
    help,
    name,
    required = false,
    disabled = false
  } = $props()
  // Unique per instance: a drawer's fields share names with the page form behind it.
  const uid = $props.id()
  const fieldId = `${name}-${uid}`
</script>

<fieldset class="fieldset">
  <legend class="fieldset-legend">{textLabel}{#if required}<span class="text-error"> *</span>{/if}</legend>
  <div class="flex gap-2">
    <input
      type="text"
      aria-label={emojiLabel}
      bind:value={emoji}
      maxlength="4"
      class="input w-16 text-center text-xl"
      class:input-error={!!error}
      {disabled}
    />
    <input
      type="text"
      id={fieldId}
      {name}
      aria-label={textLabel}
      bind:value={text}
      class="input w-full"
      class:input-error={!!error}      {disabled}
    />
  </div>
  {#if help && !error}<p class="label whitespace-normal">{help}</p>{/if}
  {#if error}<p class="text-error text-sm mt-1">{Array.isArray(error) ? error[0] : error}</p>{/if}
</fieldset>
